import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlNumberProps extends ControlTemplateProps {
    
}

export const ControlNumber: React.FC<ControlNumberProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="number" {...ComponentProps(props)} style={{ ...styles.number ?? styles.text ?? styles.input, ...props.style }} />        
    );
};